'use client';

import { isFeatureEnabled } from '@website/config/featureFlags';
import { useRegisterServiceWorker } from '@website/hooks/useRegisterServiceWorker';

/**
 * Headless client component that registers the static `/sw.js` once.
 * Mounted from `MainLayout` so the service worker is active anywhere
 * the main shell renders. Renders nothing.
 *
 * Gated by `PWA_PUSH`: when the flag is off we don't register the SW at
 * all, which keeps the entire push pipeline (subscriptions, background
 * badge updates, notification clicks) inert on stages that haven't opted
 * in yet. The hook below is still safe to call but its only job is push,
 * so there's no point paying the registration cost.
 */
export function ServiceWorkerRegistrar() {
  const pushEnabled = isFeatureEnabled('PWA_PUSH');
  useRegisterServiceWorker({ enabled: pushEnabled });
  return null;
}
